﻿import { IVoucherCategory } from "./targets/target-item";

export interface IFwtSummary {
  recipientId: number,
  recipientAlias: string,
  hardToMatch: boolean,
  isVoucherHolder: boolean,
  isPairedRecipient: boolean,
  patientCpra: number,
  patientHistoricalDeclineRatio: number,
  recipientBloodType: string,
  donorsNeeded: number;
  aboCombo: string,
  donorsCompatibleABO: string,
  aboAndAgeCompatibleDonors: string,
  categories: IVoucherCategory[],
  fwt: string,
  ewt: string,
  awt: string, 
  age: number
}
